import sortBy from "lodash/sortBy";

import type {
    AbsolutePrimarySchema,
    AbsoluteRankingCompetitorsSchema,
    RankingDataSchema,
    RelativePrimarySchema,
    RelativeRankingCompetitorsSchema,
} from "app/pages/benchmark-tracker/types/api.types";

export const createRankingTableData = (
    primary: string,
    data: RankingDataSchema,
    domainImages: Record<string, string>,
    isRelative?: boolean,
    isInverted?: boolean,
) => {
    if (!data) {
        return [];
    }

    const { primaryData, competitorsData } = data;
    const competitors = Object.keys(competitorsData);
    const rank = primaryData.rank;
    const pop = isRelative
        ? (primaryData as RelativePrimarySchema).periodOverPeriodChangeDifference
        : (primaryData as AbsolutePrimarySchema).periodOverPeriodChangeRate;
    const yoy = isRelative
        ? (primaryData as RelativePrimarySchema).yearOverYearChangeDifference
        : (primaryData as AbsolutePrimarySchema).yearOverYearChangeRate;

    const primaryTableData = {
        key: primary,
        domain: primary,
        pop,
        yoy,
        rank,
        defaultIcon: domainImages[primary],
        isPrimary: true,
        isInverted,
    };

    const competitorsTableData = competitors.reduce<typeof primaryTableData[]>((acc, competitor) => {
        const competitorData = competitorsData[competitor];
        const rank = competitorData.rank;
        const pop = isRelative
            ? (competitorData as RelativeRankingCompetitorsSchema).periodOverPeriodChangeDifference
            : (competitorData as AbsoluteRankingCompetitorsSchema).periodOverPeriodChangeRate;
        const yoy = isRelative
            ? (competitorData as RelativeRankingCompetitorsSchema).yearOverYearChangeDifference
            : (competitorData as AbsoluteRankingCompetitorsSchema).yearOverYearChangeRate;

        return [
            ...acc,
            {
                key: competitor,
                domain: competitor,
                pop,
                yoy,
                rank,
                defaultIcon: domainImages[competitor],
                isPrimary: false,
                isInverted,
            },
        ];
    }, []);

    return sortBy([primaryTableData, ...competitorsTableData], "rank", "asc");
};
